<template>
  <div>
    <counters :get-report="getReport" />
    <b-card title="Yıllık - Gelir & Gider">
      <v-select
        v-model="selectedYear"
        :options="reportData.years"
        label="year"
        :reduce="item => item.year"
        placeholder="Yıl Seçiniz"
        @input="getReport"
      />
      <column-chart
        v-if="reportData.chartData.categories"
        :categories-data="reportData.chartData.categories"
        :series-data="reportData.chartData.series"
      />
    </b-card>
  </div>
</template>
<script>
import { BCard } from 'bootstrap-vue'
import Counters from '@/views/Admin/Reports/Summary/components/Counters.vue'
import ColumnChart from '@/views/Admin/Reports/charts/ColumnChart.vue'
import vSelect from 'vue-select'

export default {
  name: 'IndexPage',
  components: {
    BCard,
    Counters,
    ColumnChart,
    vSelect,
  },
  data() {
    return {
      selectedYear: this.moment().format('Y'),
    }
  },
  computed: {
    reportData() {
      return this.$store.getters['generalReports/reportData']
    },
    loading() {
      return this.$store.getters['generalReports/loading']
    },
    summaryFilterParams() {
      return this.$store.getters['generalReports/summaryFilterParams']
    },
  },
  created() {
    this.getReport()
  },
  methods: {
    getReport() {
      this.$store.dispatch('generalReports/getReport', {
        year: this.selectedYear,
        counter_edate: this.summaryFilterParams.counter_edate,
      })
    },
  },
}
</script>
